<template>
    <v-card>
        <v-card-subtitle class="d-flex mx-2">
            <v-chip
                small
                label
                v-bind:color="getChipColor(courierinfo.status)"
                >{{ courierinfo.status }}</v-chip
            >
            <span class="ml-auto my-auto">ID: {{ courierinfo.id }}</span>
        </v-card-subtitle>
        <v-divider />
        <template v-if="courierinfo.user">
            <v-card-title>
                <v-icon class="mr-1">mdi-account</v-icon>
                {{ courierinfo.user.name }}
            </v-card-title>
            <v-card-subtitle>
                <v-icon class="mx-1" small>mdi-phone</v-icon>
                {{ courierinfo.user.phone }}
            </v-card-subtitle>
        </template>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn icon v-on:click="$emit('request-show', courierinfo)">
                <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn icon v-on:click="$emit('request-edit', courierinfo)">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon v-on:click="$emit('request-delete', courierinfo)">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import statusUtil from '@/utils/statusUtil';

export default {
    props: {
        courierinfo: {
            type: Object,
            required: true
        }
    },
    methods: {
        getChipColor(status) {
            return statusUtil.getCourierStatusColor(status);
        }
    }
};
</script>
